export const parseBlogDescription = (html: string, wordLimit = 30): string => {
  if (!html) return "";

  const text = html
    .replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "")
    .replace(/<script[^>]*>[\s\S]*?<\/script>/gi, "")
    .replace(/<[^>]+>/g, " ")
    .replace(/&nbsp;/gi, " ")
    .replace(/&amp;/gi, "&")
    .replace(/\s+/g, " ")
    .trim();

  const words = text.split(" ");

  return words.length > wordLimit ? `${words.slice(0, wordLimit).join(" ")}...` : text;
};
